module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/browser-2209d5d124c6091e33b8e029efd2e47a.png";